import { getAuth } from "firebase/auth";
import {
  ActionFunctionArgs,
  LoaderFunctionArgs,
  redirect,
} from "react-router-dom";
import { Button, message, Result } from "antd";
import { sendReviewEmail } from "~/services/email/sendReviewEmail";

export const ReviewPageLoader = async ({ request }: LoaderFunctionArgs) => {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) redirect("/signup");
  return {};
};

export type ReviewPageLoaderType = {};

export const ReviewPageAction = async ({ request }: ActionFunctionArgs) => {
  const formData = await request.formData();

  try {
    const payload = JSON.parse(formData.get("body") as string);
    const reviewEmailResult = await sendReviewEmail(payload);
    if (reviewEmailResult.success) {
      message.success("Email sent"); // TODO [Translate]
      return redirect("/");
    } else {
      message.error("Something went wrong during email sending."); // TODO [Translate]
    }
  } catch (error) {
    throw new Response(JSON.stringify({ error: error }), {
      headers: {
        "Content-Type": "application/json; utf-8",
      },
      status: 500,
    });
  }
  return {};
};

export const ReviewPageErrorBoundary = () => {
  return (
    <Result status="500" title="500" subTitle="Sorry, something went wrong.">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button type="primary" href="/">
          Back Home
        </Button>
      </div>
    </Result>
  );
};
